// extracted by mini-css-extract-plugin
module.exports = {"back":"index_back-16lVL","tooltip":"index_tooltip-yYk8k"};